<fieldset>
    <legend>STCOB Fields</legend>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField class="field field--single"
                                    [label]="'Secondary Member ID'"
                                    [text]="enrollment.SECMBRID"
                                    [disabled]="disabled"
                                    [maxlength]="16"
                                    (onValueChange)="enrollment.SECMBRID=$event"
                                    [validators]="[notBlankValidator,alphanumericValidator]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedDropDown class="wide"
                                   [selectedValue]="enrollment.RELCD"
                                   [label]="'Relationship Code'"
                                   [disabled]="'false'"
                                   (onValueChange)="relationChange($event)"
                                   [options]="RelCode">
                </ValidatedDropDown>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-8">
            <div *ngIf="!isSingleGroup" class="input-wrapper">
                <ValidatedTextField class="field field--single"
                                    [label]="'Family ID'"
                                    [text]="enrollment.FAMILYID"
                                    [disabled]="disabled"
                                    [maxlength]="18"
                                    (onValueChange)="enrollment.FAMILYID=$event"
                                    [validators]="[notBlankValidator,numericValidator]">
                </ValidatedTextField>
            </div>
            <div *ngIf="isSingleGroup" class="input-wrapper">
                <ValidatedTextField class="field field--single"
                                    [label]="'Family ID'"
                                    [text]="enrollment.FAMILYID"
                                    [disabled]="disabled"
                                    [maxlength]="18"
                                    (onValueChange)="enrollment.FAMILYID=$event"
                                    [validators]="[notBlankValidator,alphanumericValidator]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <!--<ValidatedDropDown class="wide"
                                   [selectedValue]="enrollment.PERSONCD"
                                   [label]="'Person Code'"
                                   [disabled]="'false'"
                                   (onValueChange)="personChange($event)"
                                   [options]="PersonCode">
                </ValidatedDropDown>-->

                <ValidatedTextField class="field field--single"
                                    [label]="'Person Code'"
                                    [text]="enrollment.PERSONCD"
                                    [disabled]="disabled"
                                    [maxlength]="2"
                                    [minlength]="2"
                                    (onValueChange)="enrollment.PERSONCD=$event"
                                    [validators]="[notBlankValidator,numericValidator]">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">

                <ValidatedTextField class="field field--single"
                                    [label]="'Secondary Carrier'"
                                    [text]="enrollment.SECCARRIER"
                                    [disabled]="'true'"
                                    [maxlength]="16"
                                    (onValueChange)="enrollment.SECCARRIER=$event"
                                    [validators]="[notBlankValidator,numericValidator]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField class="field field--single"
                                    [label]="'SecondaryAccount'"
                                    [text]="enrollment.SECACCOUNT"
                                    [disabled]="'true'"
                                    [maxlength]="16"
                                    (onValueChange)="enrollment.SECACCOUNT=$event"
                                    [validators]="[notBlankValidator,numericValidator]">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField class="field field--single"
                                    [label]="'Secondary Group'"
                                    [text]="enrollment.SECGROUP"
                                    [disabled]="'true'"
                                    [maxlength]="18"
                                    (onValueChange)="enrollment.SECGROUP=$event"
                                    [validators]="[notBlankValidator,numericValidator]">
                </ValidatedTextField>
            </div>
        </div>
    </div>
</fieldset>

